const Rolling = ({src}) => {
  return (
    <div className='w-full h-fit'>
        <img src={src} alt="loading" className="w-10 h-10 m-auto mt-13"/>
    </div>
  )
}

export default Rolling